import {
    RESET_PLAYER_REPORT,
    GET_PLAYER_REPORT,
    GET_PLAYER_REPORT_SUCCESS,
    GET_PLAYER_REPORT_ERROR,
    GET_PLAYER_REPORT_BY_TIME,
    GET_PLAYER_REPORT_BY_TIME_SUCCESS,
    GET_PLAYER_REPORT_BY_TIME_ERROR,
} from '../constants/ActionTypes';

const INIT_PLAYER_REPORT_STATE = {
    playerUid: "",
    playerReportData: null,
    playerReportLoader: false,
    playerReportError: null,
    playerReportByTimeLoader: false,
    playerReportByTimeError: null
}

export default (state = INIT_PLAYER_REPORT_STATE, action) => {
    switch (action.type) {
        case RESET_PLAYER_REPORT: {
            return {
                ...INIT_PLAYER_REPORT_STATE
            }
        }
        case GET_PLAYER_REPORT: {
            return {
                ...state,
                playerReportLoader: true,
                playerUid: action.payload.playerUid
            }
        }
        case GET_PLAYER_REPORT_SUCCESS: {
            return {
                ...state,
                playerReportData: action.payload,
                playerReportLoader: false,
                playerReportError: null
            }
        }
        case GET_PLAYER_REPORT_ERROR: {
            return {
                ...state,
                playerReportError: action.payload,
                playerReportLoader: false
            }
        }

        case GET_PLAYER_REPORT_BY_TIME: {
            return {
                ...state,
                playerReportByTimeLoader: true,
                playerUid: action.payload.playerUid
            }
        }
        case GET_PLAYER_REPORT_BY_TIME_SUCCESS: {
            var report = state.playerReportData
            // var finalReport = report
            // if(report !==null){
            report.custom = action.payload
            // }else{
            //     report = 
            // }
            return {
                ...state,
                playerReportData: report,
                playerReportByTimeLoader: false,
                playerReportByTimeError: null
            }
        }
        case GET_PLAYER_REPORT_BY_TIME_ERROR: {
            return {
                ...state,
                playerReportByTimeError: action.payload,
                playerReportByTimeLoader: false
            }
        }
        default:
            return state;
    }
}